export default "__VITE_ASSET__DTREXjCM__";